/**
 * Provides service functions for managing user impersonation sessions,
 * including starting impersonation, ending impersonation, and retrieving
 * the current impersonation context from the backend.
 */
import { api } from "@/api";

export async function startImpersonation(
  targetUserUpn: string,
  targetUserDisplayName: string
): Promise<any> {
  return api.impersonationStart(
    targetUserUpn,targetUserDisplayName
  );
}

export async function stopImpersonation(): Promise<any> {
  return api.impersonationStop();
}

export async function getCurrentImpersonation(): Promise<any> {
  return api.impersonationCurrent();
}